import axios from "axios";
import Config from "../utilities/Config";
const BASE_URL = `${Config.baseUrl}api/admin`;

class RoleRequests {
  getHeaders() {
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem(
        "txtconnect_ng_admin_token"
      )}`,
    };
  }

  async getRoles() {
    try {
      const response = await axios.get(`${BASE_URL}/all_roles`, {
        headers: this.getHeaders(),
      });
      return {
        success: true,
        message: response.data.message,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response.data.message,
        data: null,
      };
    }
  }

  async addRole(payload) {
    try {
      const response = await axios.post(`${BASE_URL}/create_roles`, payload, {
        headers: this.getHeaders(),
      });
      return {
        success: true,
        message: response.data.message,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response.data.message,
        data: null,
      };
    }
  }

  async updateRole(payload, roleSlug) {
    try {
      const response = await axios.put(
        `${BASE_URL}/update_roles/${roleSlug}`,
        payload,
        { headers: this.getHeaders() }
      );
      return {
        success: true,
        message: response.data.message,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response.data.message,
        data: null,
      };
    }
  }

  async getRole(roleSlug) {
    try {
      const response = await axios.get(`${BASE_URL}/show_roles/${roleSlug}`, {
        headers: this.getHeaders(),
      });
      return {
        success: true,
        message: response.data.message,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response.data.message,
        data: null,
      };
    }
  }

  async deleteRole(roleId) {
    try {
      const response = await axios.delete(`${BASE_URL}/delete_roles/${roleId}`, {
        headers: this.getHeaders(),
      });
      return {
        success: true,
        message: response.data.message,
        data: response.data.data,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response.data.message,
        data: null,
      };
    }
  }
}
const roleRequests = new RoleRequests();
export default roleRequests;
